import supplier from "./supplier";
import { PrizeService } from "./Prize.service";
import { CategoryService } from "./category/Category.service";

export default {
  ...supplier,
  prizeService: {
    class: PrizeService,
    public: true,
    arguments: [{ $ref: "apiService" }]
  },
  categoryService: {
    class: CategoryService,
    public: true,
    arguments: [{ $ref: "apiService" }]
  }
};
